import script from "./CoachesListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoachesListView.vue?vue&type=script&setup=true&lang=ts"

import "./CoachesListView.vue?vue&type=style&index=0&id=09265530&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09265530"]])

export default __exports__